import { useDeleteMenuMutation } from 'api/ordering-service/ordering-service';
import { MenuResult } from 'api/ordering-service/ordering-service.types';
import ConfirmationDrawer from 'components/drawers/confirmation-drawer/confirmation-drawer.component';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

type MenuDeleteDrawerProps = {
  open: boolean;
  close: () => void;
  drawerData: Partial<MenuResult>;
};

const MenuDeleteDrawer = ({
  open,
  close,
  drawerData,
}: MenuDeleteDrawerProps) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [deleteMenu] = useDeleteMenuMutation();

  const onConfirmationValid = async () => {
    try {
      await deleteMenu({
        catalogId: drawerData?.catalogId,
      }).unwrap();

      enqueueSnackbar(
        t('MenusDataGrid.column.actions.delete.alertMessage', {
          menuName: drawerData?.title,
        }),
        { severity: 'success' },
      );
      close();
    } catch (_e) {}
  };

  return (
    <ConfirmationDrawer
      open={open}
      close={close}
      subtitle={t('drawer.menuDeleteDrawer.subtitle', {
        menuTitle: drawerData?.title,
      })}
      submitButtonLabel={t('drawer.menuDeleteDrawer.submitButtonLabel')}
      onValid={onConfirmationValid}
      cancel={close}
      color="error"
    />
  );
};

export default MenuDeleteDrawer;
